import { store } from '../store'

export default (to, from, next) => {
  console.log('not')
  if (!store.getters.user) {
    next()
  } else {
    if (to.query.returnURL) {
      next(to.query.returnURL)
    } else {
      next('/')
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/NotAuthGuard.js